import { Navigate, RouteObject } from 'react-router-dom';

import { lazyImport } from '@/utils';

import { EngageSettingsLayout } from './EngageSettingsLayout';

const { CloudComputing } = lazyImport(
  () => import('./CloudComputing'),
  'CloudComputing',
);

const { CoverLetterTemplates } = lazyImport(
  () => import('./CoverLetterTemplates'),
  'CoverLetterTemplates',
);
const { FeesAndPayments } = lazyImport(
  () => import('./FeesAndPayments'),
  'FeesAndPayments',
);
const { GeneralSettings } = lazyImport(
  () => import('./GeneralSettings'),
  'GeneralSettings',
);
const { Outsourcing } = lazyImport(
  () => import('./Outsourcing'),
  'Outsourcing',
);
const { ServiceItemEditor } = lazyImport(
  () => import('./ServiceItemEditor'),
  'ServiceItemEditor',
);

export const engageSettingsRoute: RouteObject = {
  path: 'engage/*',
  element: <EngageSettingsLayout />,
  children: [
    { index: true, element: <Navigate to="general-settings" replace /> },
    { path: 'general-settings', element: <GeneralSettings /> },
    { path: 'fees-and-payments', element: <FeesAndPayments /> },
    { path: 'outsourcing', element: <Outsourcing /> },
    { path: 'service-item', element: <ServiceItemEditor /> },
    { path: 'cloud-computing', element: <CloudComputing /> },
    { path: 'cover-letter-templates', element: <CoverLetterTemplates /> },
    { path: '*', element: <Navigate to="general-settings" replace /> },
  ],
};
